import { Settings } from '@streamr/tv-engine';
import { EventEmitter } from 'eventemitter3';
export class ViewerCounter extends EventEmitter {
    interval;
    EXPIRATION_MS = Settings.defaultHeartbeatInterval;
    UPDATE_INTERVAL_MS = Settings.viewerCounterUpdateInterval;
    // Map of publisherId to last heartbeat timestamp
    viewers = new Map();
    handleHeartbeat(heartbeat, publisherId) {
        console.log('handleHeartbeat', heartbeat);
        this.viewers.set(publisherId, {
            lastSeenTimestamp: Date.now(),
            heartbeat,
        });
        this.emit('countChanged', this.viewers.size);
    }
    handleLeave(leave, publisherId) {
        console.log('handleLeave', leave);
        this.viewers.delete(publisherId);
        this.emit('countChanged', this.viewers.size);
    }
    getCount() {
        return this.viewers.size;
    }
    getUploadRates() {
        return Array.from(this.viewers.values()).map((broadcastMetadata) => broadcastMetadata.heartbeat.uploadRateBytesPerSecond);
    }
    getDownloadRates() {
        return Array.from(this.viewers.values()).map((broadcastMetadata) => broadcastMetadata.heartbeat.downloadRateBytesPerSecond);
    }
    getNeighborCounts() {
        return Array.from(this.viewers.values()).map((broadcastMetadata) => broadcastMetadata.heartbeat.neighbors.length);
    }
    start() {
        if (this.interval)
            return;
        this.interval = setInterval(() => {
            const now = Date.now();
            for (const [publisherId, broadcastMetadata,] of this.viewers.entries()) {
                if (now - broadcastMetadata.lastSeenTimestamp >
                    this.EXPIRATION_MS) {
                    this.viewers.delete(publisherId);
                    this.emit('countChanged', this.viewers.size);
                }
            }
        }, this.UPDATE_INTERVAL_MS);
    }
    stop() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = undefined;
        }
    }
}
